const styles = ({ COLORS, FONT_SIZES }) => ({
  pupilsMessage: {
    padding: '10px 0',
    margin: '30px 0 0',
    border: '1px solid #ECECEC',
    borderLeft: 'none',
    borderRight: 'none',
    color: COLORS.TEXT.MID_GREY.NORMAL,
    ...FONT_SIZES.BODY_LARGE.STYLE
  },
  topPanel: {
    margin: '0 0 20px',
    display: 'flex',
    flexDirection: 'row'
  },
  searchHolder: {
    flex: '1'
  },
  filterControlsContainer: {
    margin: '0 0 15px'
  },
  addPupilHolder: {
    padding: '0 0 0 15px',
    margin: '0 0 0 15px',
    position: 'relative',
    '&:after': {
      position: 'absolute',
      content: '""',
      height: '30px',
      top: '5px',
      left: '0',
      width: '1px',
      backgroundColor: '#ddd'
    }
  },
  showingSelectedHolder: {
    display: 'flex',
    alignItems: 'center',
    margin: '0 0 15px'
  },
  showAllPupils: {
    fontWeight: 'bold',
    color: COLORS.BLUE.NORMAL,
    cursor: 'pointer',
    margin: '0 0 0 5px'
  }
})

export default styles
